export const PGM_OPTION_TYPE_BOOLEAN = 'boolean'
export const PGM_OPTION_TYPE_NUMBER = 'number'
export const PGM_OPTION_TYPE_UNSIGNED_8 = 'unsigned [8]'
export const PGM_OPTION_TYPE_NUMBER_ARRAY = 'number []'
export const PGM_OPTION_TYPE_BOOLEAN_8 = 'boolean [8]'
